import { Divider, Text } from '@mantine/core';
import { DwFormReviewCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/DwFormReviewCard';
import { CategorySection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/styled';
import {
	FormCategoryGroup,
	FormReviewCardData,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/types.ts';

interface Props {
	group: FormCategoryGroup;
	selectedTemplateId?: string;
	onSelectForm: (card: FormReviewCardData) => void;
	showDivider: boolean;
}

export const CategoryGroupSection = ({
	group,
	selectedTemplateId,
	onSelectForm,
	showDivider,
}: Props) => {
	return (
		<>
			<CategorySection>
				<Text size="B6Bold" c="dark.8">
					{group.title}
				</Text>
				{group.cards.map((card) => (
					<DwFormReviewCard
						key={card.templateId}
						card={card}
						isSelected={selectedTemplateId === card.templateId}
						onClick={() => onSelectForm(card)}
					/>
				))}
			</CategorySection>
			{showDivider && <Divider color="gray.2" />}
		</>
	);
};
